import type { DataCaptureView } from '@scandit/web-datacapture-core'
import {
  type LabelCapture,
  LabelCaptureBasicOverlay,
  LabelCaptureFeedback,
  LabelCaptureValidationFlowOverlay,
} from '@scandit/web-datacapture-label'
import type { ControllerDeps, Teardown } from './PresetController'

/**
 * Shared activate-side logic for any preset that uses the ValidationFlowOverlay.
 * The overlay drives the camera/mode lifecycle through its own UI, so we
 * deliberately don't call setEnabled or switch the frame source here.
 */
export async function activateValidationFlow(
  mode: LabelCapture,
  view: DataCaptureView,
  deps: ControllerDeps
): Promise<Teardown> {
  mode.feedback = LabelCaptureFeedback.default

  const overlay = await LabelCaptureValidationFlowOverlay.withLabelCaptureForView(mode, view)

  const basicOverlay = await LabelCaptureBasicOverlay.withLabelCaptureForView(mode, view)
  overlay.listener = {
    onValidationFlowLabelCaptured: (fields) => deps.listStore.addFromLabelFields(fields),
    onManualInput: () => {},
  }

  return async () => {
    await view.removeOverlay(overlay)
    await view.removeOverlay(basicOverlay)
  }
}
